module.exports = __webpack_public_path__ + "static/media/flag.152c029c.png";